import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { Uris } from 'src/app/Services/public/Uris';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';
import { field } from '../interfaces/fields.interface';

@Injectable({
  providedIn: 'root',
})
export class FieldService {
  private pathField = new BehaviorSubject<google.maps.LatLngLiteral[]>([]);
  dataField$ = this.pathField.asObservable();

  private reloadPetition = new BehaviorSubject<boolean>(false);
  reloadPetition$ = this.reloadPetition.asObservable();
  constructor(
    public http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction
  ) {}
  setReloadPetition() {
    this.reloadPetition.next(!this.reloadPetition.getValue());
  }
  setPathField(path: google.maps.LatLngLiteral[]) {
    this.pathField.next(path);
  }

  pushPointSector(path: google.maps.LatLngLiteral) {
    let currentPath = [...this.pathField.getValue()];
    console.log('currentPath', currentPath);
    currentPath.splice(currentPath.length - 1, 0, {
      lat: path.lat,
      lng: path.lng,
    });

    this.pathField.next(currentPath);
  }

  register(value: any): Observable<field> {
    return this.http
      .post<field>(`${Uris.API_FIELDS}`, value, this.globalFunction.headers())
      .pipe(
        map((resp: field) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  listFields(): Observable<field[]> {
    return this.http
      .get<field[]>(`${Uris.API_FIELDS}`, this.globalFunction.headers())
      .pipe(
        map((resp: field[]) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  getFieldById(value): Observable<field> {
    return this.http
      .get<field>(`${Uris.API_FIELDS}${value}/`, this.globalFunction.headers())
      .pipe(
        map((resp: field) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  deleteField(value: any): Observable<field> {
    return this.http
      .delete<field>(
        `${Uris.API_FIELDS}${value}/`,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: field) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  editField(value: any, id: any): Observable<field> {
    return this.http
      .put<field>(
        `${Uris.API_FIELDS}${id}/`,
        value,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
}
